import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Box, Stack, TextField, } from '@mui/material';
import { brightGrey, green, red, bgColorLight, } from '../../tss/colors';
import CustomButton from '../../common/CustomButton';
import NoteTitle from './NoteTitle';
const StyledTextField = styled(TextField)(() => ({
    padding: 0,
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: bgColorLight,
        },
        // '&:hover fieldset': {
        //   borderColor: 'yellow',
        // },
        '&.Mui-focused fieldset': {
            borderColor: bgColorLight,
        },
    },
}));
const NoteCreateOrEdit = ({ value, disabled, handleFocus, handleChange, handleSave, handleCancel, }) => (_jsx(Box, { sx: { p: '10px', pt: 0 }, children: _jsxs(Box, { sx: { backgroundColor: brightGrey, p: 1, borderRadius: 1 }, children: [_jsx(Box, { sx: { m: -1 }, children: _jsx(NoteTitle, { title: "ADD NEW NOTE" }) }), _jsx(StyledTextField, { fullWidth: true, multiline: true, minRows: 4, value: value, onFocus: handleFocus, autoFocus: true, onChange: (e) => handleChange(e?.target?.value), variant: "outlined" // or standard when disableUnderline
                , InputProps: {
                // disableUnderline: true,
                } }), _jsxs(Stack, { direction: "row", justifyContent: "space-between", sx: { mt: 2 }, children: [_jsx(CustomButton, { label: "CANCEL", onClick: handleCancel, customStyle: { color: red, width: 90 } }), _jsx(CustomButton, { label: "SAVE", disabled: disabled, customStyle: { color: green, width: 90 }, onClick: handleSave })] })] }) }));
export default NoteCreateOrEdit;
//# sourceMappingURL=NoteCreateOrEdit.js.map